<template>
  <a-modal
    v-model="visible"
    wrapClassName="contacts-modal"
    @cancel="$emit('cancel')"
    :destroyOnClose="true"
    :footer="null"
    :centered="true"
    width="450px"
  >
    <h3 slot="title">{{ $t('contacts.modal.headline') }}</h3>
    <p>{{ $t('contacts.modal.p1') }}</p>
    <p class="p2">{{ $t('contacts.modal.p2') }}</p>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';

p {
  font-size: $font-size-large;
  letter-spacing: 0.17px;
  line-height: 22px;
  text-align: center;
  padding-bottom: 10px;
}
.p2 {
  color: $grey;
}
</style>
<style lang="scss">
.contacts-modal {
  .ant-modal-title {
    display: flex;
    justify-content: center;
  }
}
</style>
